import FilterGroupLayout from './FilterGroupLayout';
import { FilterGroupContextProvider, useFilterGroupContext } from './FilterGroupContext';
import './FilterGroup.scss';

const FilterGroup = ({
  label = 'Filters',
  filterConfig,
  className,
  style,
  onUpdate,
  onClear,
  popperOptions = {
    placement: 'bottom-end',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 6]
      }
    }]
  }
}) => (
  <FilterGroupContextProvider
    popperOptions={popperOptions}
    filterConfig={filterConfig}
    onUpdate={onUpdate}
    onClear={onClear}
  >
    <FilterGroupLayout
      label={label}
      className={className}
      style={style}
    />
  </FilterGroupContextProvider>
);

export {
  FilterGroup,
  useFilterGroupContext
};
